export const MIXED_LESSON_ID = "oylan-mix";
export const MIXED_BKT_STORAGE_KEY = "oylan-mix-bkt";

export function bktOwnerId(lesson) {
    return lesson?.metaLessonId || lesson?.id;
}

export function progressKeyForLesson(lessonId, regularKey) {
    return lessonId === MIXED_LESSON_ID ? MIXED_BKT_STORAGE_KEY : regularKey;
}

export function isOylanProgressKey(key, regularKey) {
    return key.startsWith(regularKey) || key.startsWith("oylan-");
}

// BKT answer updates mutate the live parameter objects. Restore them in place so
// Problem.js references remain valid when switching between a topic and the mix.
export function restoreBktParams(live, initial, saved) {
    for (const [skill, params] of Object.entries(initial)) {
        if (live[skill]) Object.assign(live[skill], params);
        else live[skill] = { ...params };
    }
    if (saved && typeof saved === "object") {
        for (const [skill, params] of Object.entries(saved)) {
            if (live[skill] && params && typeof params === "object") {
                Object.assign(live[skill], params);
            }
        }
    }
    return live;
}
